import React from 'react';
import { Outlet } from 'react-router-dom';
import { Flexbox } from '../../components/action/Flexbox';
import './Review.scss';
const SIDEBAR = [
  {
    name: 'Your Feed',
    mobile_name: 'Feed',
    id: 0,
    route: '/takes/feed',
  },
  {
    name: 'Twitter Takes',
    mobile_name: 'X Takes',
    id: 1,

    route: '/takes/twittertakes',
  },
  {
    name: 'Write a Take',
    mobile_name: 'Write',
    id: 2,
    route: '/takes/write',
  },

  {
    name: 'Invite',
    mobile_name: 'Invite',
    id: 3,
    route: '/takes/invite',
  },
];

const ReviewProvider = () => {
  return (
    <Flexbox className='review_wrapper' alignItems='flex-start'>
      <div className='review_wrapper__content'>
        {/* <FlexboxColumn className='review_wrapper__sidebar' justifyContent={'flex-start'} alignItems={'flex-start'}>
              <div className='review_wrapper__sidebar_filler'></div>
              {SIDEBAR.map(item => (
                <NavLink to={item?.route} activeclassname='review_wrapper__sidebar_active'>
                  <ThemedText.P>{item?.name}</ThemedText.P>
                </NavLink>
              ))}
            </FlexboxColumn> */}
        <Outlet />
      </div>
    </Flexbox>
  );
};

export default ReviewProvider;
